import * as React from 'react'
import { useFormContext } from 'react-hook-form'

import {
  FieldElementWrapperProps,
  FieldWrapper
} from '~/components/field-wrapper/FieldWrapper'
import { useFieldError } from '~/components/form/useFieldError'
import { useFormCustomContext } from '~/components/form/useFormCustomContext'
import { Select, SelectProps } from '~/components/select/Select'

type SelectFieldProps = SelectProps & FieldElementWrapperProps

export const SelectField = ({
  className,
  hideLabel,
  children,
  name,
  label,
  validation,
  prompt,
  description,
  appearance,
  theme,
  ...remainingProps
}: SelectFieldProps) => {
  const { register } = useFormContext()
  const context = useFormCustomContext()
  const { error } = useFieldError(name)
  const ref = validation ? register(validation) : register
  const formAppearance = context?.appearance || appearance
  const formTheme = context?.theme ?? theme

  return (
    <FieldWrapper
      className={className}
      description={description}
      error={error}
      fieldId={name}
      hideLabel={hideLabel}
      label={label}
      prompt={prompt}
      required={Boolean(validation?.required)}
      appearance={formAppearance}
    >
      <Select
        name={name}
        id={name}
        appearance={formAppearance}
        theme={formTheme}
        {...remainingProps}
        ref={ref}
        {...(error && { state: 'error' })}
      >
        {children}
      </Select>
    </FieldWrapper>
  )
}

SelectField.displayName = 'SelectField'
